export default __webpack_public_path__ + "static/media/request_gold.1fc8c449.png";